import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { forgotPasswordRequest } from '@/api/user';
import i18n from '@/i18n';
import { forgotPassword } from '../actions';

const forgotPasswordEpic: Epic = (action$) =>
  action$.pipe(
    filter(forgotPassword.match),
    request(({ payload }) => forgotPasswordRequest(payload), forgotPassword),
  );

const forgotPasswordSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(forgotPassword.succeeded.match),
    mergeMap(() => [
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: i18n.t('FORGOT_PASSWORD_SUCCESS'),
      }),
    ]),
  );

export default combineEpics(forgotPasswordEpic, forgotPasswordSucceededEpic);
